import { render, staticRenderFns } from "./SIRepository.vue?vue&type=template&id=e3ed0bf4&"
import script from "./SIRepository.vue?vue&type=script&lang=js&"
export * from "./SIRepository.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports